//Формирование данных графика по периодам

export function getArrayData(
  array: any[],
  colorArray: any[],
  yValue: number,
  getColorIndexFunc: Function,
) {
  const res: any[] = [];
  let sz = 0;
  array.forEach((elem: any) => {
    const colorIndex = getColorIndexFunc(elem);
    if (sz == 0 || res[sz - 1].x != elem.x) {
      res.push({
        x: elem.start,
        y: yValue,
        elem: {
          color: colorArray[colorIndex],
        },
      });
      sz++;
    } else {
      if (sz != 0) {
        const prevElem = res[sz - 1];
        prevElem.elem = {
          color: colorArray[colorIndex],
        };
      }
      sz++;
    }
    res.push({
      x: elem.end,
      y: yValue,
    });
    sz++;
  });
  return res;
}
